import { Box, Paper } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

import { useIsSmallScreen, legacyMakeStyles } from '../helper';
import theme from '../theme';
import Loader from '../Components/generic/Loader';

type Props = {
  loading?: boolean;
  page?: boolean;
  style?: React.CSSProperties;
  reference?: React.Ref<HTMLDivElement> | undefined;
  header?: ReactElement;
  labelLoading?: ReactElement;
  loader?: ReactElement;
  elevation?: number;
  children?: ReactNode;
};

const Container: React.FC<Props> = (props) => {
  const {
    children,
    loading,
    page,
    style,
    reference,
    header,
    labelLoading,
    loader,
    elevation,
    ...other
  } = props;
  const classes = useStyles();

  const isTelaPequena = useIsSmallScreen();

  return (
    <div style={{ width: '100%' }}>
      <Paper
        elevation={elevation !== undefined ? elevation : 1}
        ref={reference}
        style={style}
        sx={{
          ...classes.container,
          ...(isTelaPequena && { borderRadius: '0 0 8px 8px' })
        }}
        {...other}
      >
        {header}
        {loading ? (
          <Box component="div" sx={classes.loading}>
            {loader ? loader : <Loader />}
            {labelLoading ? labelLoading : ''}
          </Box>
        ) : (
          <Box component="div" sx={classes.padding}>
            {children}
          </Box>
        )}
      </Paper>
    </div>
  );
};

const useStyles = legacyMakeStyles({
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
    flexDirection: 'column'
  },
  container: {
    width: '100%',
    overflow: 'hidden',
    borderRadius: '25px',
    // [theme.breakpoints.up('lg')]: {
    //   backgroundColor: '#0f0'
    // },
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100%',
      width: '100%'
    }
  },
  padding: {
    [theme.breakpoints.up('sm')]: {
      padding: '30px'
    },
    [theme.breakpoints.up('lg')]: {
      padding: '30px',
      paddingLeft: '50px',
      paddingRight: '50px'
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: '30px',
      paddingRight: '20px',
      paddingLeft: '20px',
      paddingBottom: '30px'
    }
  }
});

export default Container;
